<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<div class="modal-header">
  <h3 class="modal-title">Preview Your Custom Onboarding</h3>
</div>
<div class="modal-body">
  <app-nexleader-custom-onboarding-card
    *ngIf="groupId"
    [groupId]="groupId"
  ></app-nexleader-custom-onboarding-card>
</div>
<div class="modal-footer">
  <button class="btn btn-default" type="button" (click)="close()">Close</button>
</div>
